import { lazy, Suspense } from "react";
import Page from "@jumbo/shared/Page";
import AccessMiddleware from "./middleware/auth/AccessMiddleware";
import { CHALLAN_ROUTE, CHALLAN_ADD_ROUTE, CHALLAN_VIEW_ROUTE, CHALLAN_EDIT_ROUTE } from "app/utils/constants/routeConstant";
import { LoadablePage } from "app/utils/loadablePage";

// Lazy imports
const Challan = lazy(() => import("app/pages/Challan"));
const CreateChallan = lazy(() => import("app/pages/Challan/CreateChallan"));
const EditChallan = lazy(() => import("app/pages/Challan/EditChallan"));
const ViewChallan = lazy(() => import("app/pages/Challan/ViewChallan"));

export const challanModuleRoute = [
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "challan_permission", "view"],
      },
    ],
    routes: [
      {
        path: CHALLAN_ROUTE,
        element: LoadablePage(Challan),
      },
      {
        path: CHALLAN_ADD_ROUTE,
        element: LoadablePage(CreateChallan),
      },
      {
        path: CHALLAN_EDIT_ROUTE,
        element: LoadablePage(EditChallan),
      },
      {
        path: CHALLAN_VIEW_ROUTE,
        element: LoadablePage(ViewChallan),
      },
    ],
  },
];
